import React from 'react';
import TermItemSelectField from '../../../../Term/Components/TermItemSelectField';
import { BaseFieldProps } from '../../Inputs/BaseField/BaseField';
// @ts-ignore
import styles from './P1MedicamentFiled.module.scss';
import { TermItemSelectTemplateItem } from '../../../../Term/Components/TermItemSelect';

interface ItemProps {
	item: TermItemSelectTemplateItem;
}

const ItemComponent: React.FC<ItemProps> = ({ item }) => {
	const data = item.data;

	const handleSelect = () => {
		item.selectOption({
			value: item.value,
			label: data.label,
		});
	};

	return (
		<div className={styles.wrapper} onClick={handleSelect}>
			<div className={styles.title}>{data.label}</div>
			<div className={styles.subtitle}>{data.termItem.value3}</div>
		</div>
	);
};

const P1MedicamentFiled: React.FC<BaseFieldProps> = props => {
	return (
		<TermItemSelectField
			{...props}
			termType='p1_medicaments'
			ItemTemplate={(item: TermItemSelectTemplateItem) => (
				<ItemComponent item={item} />
			)}
		/>
	);
};

export default P1MedicamentFiled;
